import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const NotAvailableIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M21 20.3333L20.3333 21L3 3.66667L3.66667 3L21 20.3333Z' fill='currentColor' />
            <Path
                d='M11.4853 14.2871C11.6738 14.2871 11.8662 14.2937 12.0626 14.3055L17.3475 19.5904H4.4004V17.8088C4.40041 17.0876 4.83837 16.4367 5.71518 15.8569C6.45057 15.3619 7.41278 14.9662 8.60069 14.6692C9.64706 14.4147 10.6086 14.2871 11.4853 14.2871Z'
                fill='currentColor'
            />
            <Path
                d='M13.9206 14.567C14.0685 14.5985 14.2183 14.6323 14.3699 14.6692C14.88 14.7967 15.3482 14.9443 15.7749 15.1084L18.5702 17.9036V19.2166L13.9206 14.567Z'
                fill='currentColor'
            />
            <Path
                d='M12.8802 12.2136C12.5503 12.3597 12.2041 12.4508 11.8398 12.4862L7.98197 8.62838C8.0171 8.26552 8.10591 7.91721 8.2499 7.58337L12.8802 12.2136Z'
                fill='currentColor'
            />
            <Path
                d='M9.85838 12.1013C9.8139 12.0775 9.76871 12.0545 9.72488 12.0286C9.18758 11.7104 8.75959 11.2824 8.44141 10.7451C8.41509 10.7007 8.39097 10.6549 8.36683 10.6098L9.85838 12.1013Z'
                fill='currentColor'
            />
            <Path
                d='M11.4853 5.42062C12.1216 5.42062 12.7083 5.57945 13.2457 5.89755C13.7831 6.21573 14.211 6.65071 14.5292 7.2022C14.8473 7.75365 15.0069 8.34751 15.007 8.98378C15.007 9.62018 14.8474 10.2077 14.5292 10.7451C14.3427 11.0599 14.1178 11.336 13.8561 11.5756L8.8769 6.59637C9.12031 6.32172 9.40268 6.08833 9.72488 5.89755C10.2622 5.57945 10.849 5.42062 11.4853 5.42062Z'
                fill='currentColor'
            />
        </>
    ),
})

NotAvailableIcon.displayName = 'NotAvailableIcon'
